import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import { getLabelMessage } from '@gef-ui/localization/messages';

import DatePickerFullWidth from 'components/atoms/GefMui/DatePickerFullWidth';
import ResolverSettings from 'components/atoms/GefMui/ResolverSettings';
import { ALLOW_DEADLINE_DATE } from 'features/common/acl/constants';
import { FIELDS, TASK_FORWARDING_FORM_NAME } from 'features/views/taskForwarding/form';
import { getTommorowAsDateObj } from 'utils/apiDateTime';

export const Form = () => {
	return (
		<>
			<Stack
				spacing={2}
				sx={{
					ml: 2,
				}}
			>
				<Typography variant="h5" color="text.primary">
					{getLabelMessage('taskForwarding:taskParametersTitle')}
				</Typography>
				<AccessControl accessLevel={ALLOW_DEADLINE_DATE}>
					<Grid container>
						<Grid size={4}>
							<DatePickerFullWidth
								fieldName={FIELDS.deadlineDate}
								label={getLabelMessage('taskForwarding:deadlineDate')}
								minDate={getTommorowAsDateObj()}
							/>
						</Grid>
					</Grid>
				</AccessControl>
			</Stack>
			<ResolverSettings
				formName={TASK_FORWARDING_FORM_NAME}
				showSectionHeader={false}
				showNonUniqueSolverDialog={false}
			/>
		</>
	);
};

export default Form;
